import { Outlet } from 'react-router-dom'
export const PageContainer: React.FC = () => <Outlet />
